@if(view === 'tables'){
<div class="max-w-7xl mx-auto flex flex-col gap-4">
  <section class="flex justify-between items-center">
    <h1 class="text-2xl font-bold text-gray-800">Nuevo pedido de restaurante</h1>
    <a routerLink="/tickets"
      class="text-[10px] font-bold text-slate-400 hover:text-slate-700 uppercase tracking-widest">
      Volver a tickets
    </a>
  </section>

  <p class="text-sm text-slate-500">Selecciona una mesa libre para empezar a tomar el pedido, o una mesa ocupada para modificar su pedido.</p>

  @if(loadingTables){
  <p class="text-sm text-slate-400">Cargando mesas...</p>
  } @else if(tables.length === 0){
  <div class="rounded-2xl border border-dashed border-slate-300 bg-slate-50 p-8 text-center text-sm text-slate-500">
    No hay mesas creadas todavía. Ve a <a routerLink="/tables" class="text-blue-600 font-bold hover:underline">Mesas</a>
    para crear la primera.
  </div>
  } @else {
  <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
    @for(table of tables; track table.id){
    <button type="button" (click)="selectTable(table)"
      [disabled]="table.status !== 'free' && table.status !== 'occupied'"
      class="flex flex-col items-start gap-2 rounded-2xl border-2 p-4 text-left transition-all shadow-sm"
      [class]="tableStatus(table.status).classes"
      [class.cursor-not-allowed]="table.status !== 'free' && table.status !== 'occupied'"
      [class.cursor-pointer]="table.status === 'free' || table.status === 'occupied'"
      [class.opacity-70]="table.status !== 'free' && table.status !== 'occupied'">
      <span class="text-lg font-black uppercase tracking-tight">{{ table.name }}</span>
      @if(table.capacity){
      <span class="text-[10px] font-bold uppercase tracking-widest opacity-70">{{ table.capacity }} comensales</span>
      }
      <span class="mt-1 text-[10px] font-bold uppercase tracking-widest px-2 py-0.5 rounded-full bg-white/60">
        {{ tableStatus(table.status).label }}
      </span>
    </button>
    }
  </div>
  }
</div>
}

@if(view === 'order'){
<form [formGroup]="saveForm" (submit)="false"
  class="flex flex-col gap-2 max-w-7xl mx-auto md:h-[calc(100dvh-4rem)] pb-20 md:pb-0">

  <!-- Cabecera de la mesa -->
  <section class="flex items-center justify-between gap-3 bg-white border border-slate-200 rounded-2xl shadow-sm px-3 py-2">
    <div class="flex items-center gap-3 min-w-0">
      <button type="button" (click)="backToTables()"
        class="h-11 px-3 bg-slate-100 text-slate-600 hover:bg-slate-200 active:scale-95 rounded-xl font-bold text-xs tracking-widest transition-all uppercase shrink-0">
        ← Mesas
      </button>

      <div class="flex flex-col min-w-0">
        <span class="text-[10px] font-semibold text-slate-400 uppercase tracking-wider">Mesa</span>
        <span class="text-xl font-black text-slate-800 truncate leading-tight">{{ selectedTable?.name }}</span>
      </div>

      @if(editingTicketId){
      <span class="hidden sm:inline text-[10px] font-bold text-amber-600 bg-amber-50 border border-amber-200 uppercase tracking-widest px-2 py-1 rounded-full">
        Modificando pedido
      </span>
      }
    </div>

    <label for="tax_included" class="flex items-center gap-2 cursor-pointer shrink-0">
      <span class="text-[10px] font-bold text-slate-400 uppercase tracking-widest text-right leading-tight">IVA<br class="sm:hidden"> incluido</span>
      <input type="checkbox" id="tax_included" formControlName="tax_included"
        class="w-5 h-5 border-2 border-black rounded accent-black cursor-pointer">
    </label>
  </section>

  <div class="flex-1 min-h-0 grid grid-cols-1 md:grid-cols-[minmax(0,1fr)_380px] gap-2">

    <!-- ── Carta ── -->
    <section class="md:flex min-h-0 flex-col bg-white border border-slate-200 rounded-2xl shadow-sm overflow-hidden"
      [class.hidden]="mobilePanel !== 'menu'" [class.flex]="mobilePanel === 'menu'">

      <div class="p-2 border-b border-slate-100 flex flex-col gap-2">
        <div class="relative">
          <span class="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400">🔍</span>
          <input type="text" #mainSearch (input)="searchQuery = $any($event.target).value"
            (keydown.enter)="$event.preventDefault(); $event.stopPropagation(); addFirstProduct(mainSearch)"
            placeholder="BUSCAR EN LA CARTA..."
            class="w-full h-12 pl-12 pr-12 bg-slate-50 border border-slate-200 rounded-2xl text-sm font-bold text-slate-700 focus:bg-white focus:ring-4 focus:ring-blue-500/10 outline-none transition-all uppercase tracking-wider">
          @if(searchQuery){
          <button type="button" (click)="clearSearch(mainSearch)"
            class="absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full text-slate-400 hover:bg-slate-200 hover:text-slate-700">✕</button>
          }
        </div>

        <!-- Familias -->
        <div class="flex gap-2 overflow-x-auto pb-1 -mx-1 px-1">
          <button type="button" (click)="selectCategory('all', mainSearch)"
            class="h-11 px-4 rounded-xl border-2 font-black text-xs uppercase tracking-wider whitespace-nowrap transition-all active:scale-95"
            [class]="activeCategoryId === 'all' && !searchQuery ? 'bg-slate-900 border-slate-900 text-white' : 'bg-white border-slate-200 text-slate-600'">
            Todo
          </button>
          @for(category of menuCategories; track category.id){
          @let colors = categoryColors(category.id);
          <button type="button" (click)="selectCategory(category.id, mainSearch)"
            class="h-11 px-4 rounded-xl border-2 font-black text-xs uppercase tracking-wider whitespace-nowrap transition-all active:scale-95 flex items-center gap-2"
            [class]="activeCategoryId === category.id && !searchQuery ? colors.active : 'bg-white border-slate-200 text-slate-600'">
            @if(activeCategoryId !== category.id || searchQuery){
            <span class="w-2.5 h-2.5 rounded-full" [class]="colors.dot"></span>
            }
            {{ category.name }}
          </button>
          }
        </div>
      </div>

      <div class="flex-1 min-h-0 overflow-y-auto p-2">
        @if(menuProducts.length === 0){
        <p class="py-10 text-center text-sm font-bold text-slate-400 uppercase tracking-wider">No hay productos</p>
        } @else {
        <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2">
          @for(prod of menuProducts; track prod.id){
          @let qty = orderedQuantity(prod.id);
          <button type="button" (click)="tapProduct(prod)"
            class="relative min-h-24 flex flex-col justify-between gap-2 p-3 rounded-2xl border-2 text-left select-none transition-all active:scale-95 hover:shadow-md ring-blue-500/40"
            [class]="categoryColors(prod.category_id ?? null).tile"
            [class.ring-4]="qty > 0">
            <span class="text-sm font-black uppercase leading-tight line-clamp-3 pr-6">{{ prod.name }}</span>
            <span class="text-base font-black">{{ getPrice(prod) | number:'1.2-2' }} €</span>

            @if(qty > 0){
            <span class="absolute top-2 right-2 min-w-7 h-7 px-1.5 rounded-full bg-blue-600 text-white text-xs font-black flex items-center justify-center shadow">
              {{ qty }}
            </span>
            }
          </button>
          }
        </div>
        }
      </div>
    </section>

    <!-- ── Comanda ── -->
    <section class="md:flex min-h-0 flex-col bg-white border border-slate-200 rounded-2xl shadow-sm overflow-hidden"
      [class.hidden]="mobilePanel !== 'order'" [class.flex]="mobilePanel === 'order'">

      <div class="flex items-center justify-between px-4 py-3 border-b border-slate-100 bg-slate-50/60">
        <span class="text-sm font-black text-slate-800 uppercase tracking-widest">Comanda</span>
        <span class="text-[10px] font-bold text-slate-500 uppercase tracking-widest">{{ orderedUnits }} uds.</span>
      </div>

      <div class="flex-1 min-h-0 overflow-y-auto" formArrayName="items">
        @for (item of itemControls; track item; let i = $index) {
        @let p = getProductInfo(item.get('product_id')?.value);
        <div [formGroupName]="i" class="border-b border-slate-100" [class.bg-blue-50]="expandedLine === i">
          <div class="flex items-center gap-2 px-3 py-2">
            <button type="button" (click)="toggleLine(i)" class="flex-1 min-w-0 text-left py-1">
              <span class="block text-sm font-bold text-slate-800 uppercase leading-tight truncate">{{ item.get('name')?.value }}</span>
              <span class="block text-[11px] font-bold text-slate-400">
                {{ item.get('price')?.value | number:'1.2-2' }} €
                @if(item.get('discount')?.value){ · -{{ item.get('discount')?.value }}% }
              </span>
            </button>

            <div class="flex items-center shrink-0">
              <button type="button" (click)="decrementLine(i)"
                class="w-10 h-10 rounded-xl bg-slate-100 hover:bg-slate-200 active:scale-90 text-lg font-black text-slate-700 transition-all">−</button>
              <span class="w-9 text-center text-base font-black text-slate-800">{{ item.get('quantity')?.value }}</span>
              <button type="button" (click)="incrementLine(i)"
                class="w-10 h-10 rounded-xl bg-slate-900 hover:bg-slate-700 active:scale-90 text-lg font-black text-white transition-all">+</button>
            </div>

            <span class="w-16 text-right text-sm font-black text-slate-800 font-mono shrink-0">{{ getAndCalculateWithTax(item) }}€</span>
          </div>

          @if(expandedLine === i){
          <div class="px-3 pb-3 flex flex-col gap-2">
            <div class="grid grid-cols-3 gap-2">
              <label class="flex flex-col gap-1">
                <span class="text-[10px] font-bold text-slate-400 uppercase tracking-widest">Cant.</span>
                <input type="number" formControlName="quantity" min="1"
                  class="h-10 px-2 bg-white border border-slate-200 rounded-lg text-center font-bold text-slate-700 text-sm outline-none">
              </label>
              <label class="flex flex-col gap-1">
                <span class="text-[10px] font-bold text-slate-400 uppercase tracking-widest">Precio €</span>
                <input type="text" inputmode="decimal" decimalInput formControlName="price"
                  class="h-10 px-2 bg-white border border-slate-200 rounded-lg text-right font-bold text-slate-700 text-sm outline-none">
              </label>
              <label class="flex flex-col gap-1">
                <span class="text-[10px] font-bold text-slate-400 uppercase tracking-widest">Dto. %</span>
                <input type="number" formControlName="discount"
                  class="h-10 px-2 bg-white border border-slate-200 rounded-lg text-right font-bold text-slate-700 text-sm outline-none">
              </label>
            </div>

            @if(p?.special_measures){
            <div class="flex flex-wrap gap-1 items-center">
              @for (m of item.get('special_measures')?.value; track $index) {
              <span class="text-[9px] font-mono bg-slate-100 text-slate-500 px-1.5 rounded border border-slate-200">
                {{m.q}} x {{m.h}}x{{m.w}}x{{m.t}}
              </span>
              }
              <button type="button" (click)="openMeasures(i, item.get('special_measures')?.value, p.special_measures)"
                class="text-[10px] font-bold text-blue-600 hover:underline">Editar medidas</button>
            </div>
            }

            <div class="flex justify-between items-center">
              <span class="text-[10px] font-bold text-slate-400 uppercase tracking-widest">Sin IVA: {{ getAndCalculateWithOutTax(item) }}€</span>
              <button type="button" (click)="removeItem(i)"
                class="h-9 px-3 rounded-lg bg-red-50 text-red-600 hover:bg-red-100 text-[10px] font-bold uppercase tracking-widest">
                Eliminar línea
              </button>
            </div>
          </div>
          }
        </div>
        } @empty {
        <div class="h-full flex flex-col items-center justify-center gap-2 py-10 text-center px-6">
          <span class="text-3xl">🍽️</span>
          <p class="text-sm font-bold text-slate-400 uppercase tracking-wider">Comanda vacía</p>
          <p class="text-xs text-slate-400">Pulsa los productos de la carta para añadirlos.</p>
        </div>
        }
      </div>

      <div class="border-t border-slate-100 p-3 flex flex-col gap-2">
        <custom-input label="Notas" type="text" placeholder="Alergias, peticiones especiales..."
          [formControlItem]="saveForm.get('notes')"></custom-input>

        <custom-select label="Cliente" [formControlItem]="saveForm.controls['client_id']"
          [options]="dropdowns.clients" bindValue="id" bindLabel="name" bindSubLabel="nif" [isMultiple]="false"
          placeholder="Selecciona un cliente (opcional)"
          [createComponent]="clientFormComponent" (itemCreated)="getDropdowns()">
        </custom-select>

        <div class="flex items-center justify-between gap-2">
          <span class="text-[10px] font-bold text-slate-400 uppercase tracking-widest">Descuento</span>
          <div class="flex items-center gap-2">
            <div class="flex bg-slate-100 p-1 rounded-xl">
              <label class="cursor-pointer">
                <input type="radio" [value]="0" formControlName="discount_absolute_bool" class="peer hidden">
                <span class="block px-3 py-1 rounded-lg text-xs font-bold text-slate-500 peer-checked:bg-slate-900 peer-checked:text-white transition-all">%</span>
              </label>
              <label class="cursor-pointer">
                <input type="radio" [value]="1" formControlName="discount_absolute_bool" class="peer hidden">
                <span class="block px-3 py-1 rounded-lg text-xs font-bold text-slate-500 peer-checked:bg-slate-900 peer-checked:text-white transition-all">€</span>
              </label>
            </div>
            <input type="text" inputmode="decimal" decimalInput formControlName="discount" placeholder="0"
              class="w-20 h-9 px-2 bg-slate-50 border border-slate-200 rounded-lg text-right font-bold text-slate-700 text-sm outline-none">
          </div>
        </div>
      </div>

      <div class="bg-slate-900 text-white p-3 flex flex-col gap-2">
        <div class="flex items-end justify-between">
          <div class="flex flex-col">
            <span class="text-slate-500 font-bold uppercase text-[9px] tracking-widest">Base imponible</span>
            <span class="text-sm font-bold">{{ saveForm.get('subtotal')?.value }}€</span>
          </div>
          <div class="flex items-baseline">
            <span class="text-4xl font-black tracking-tighter text-blue-400">{{ saveForm.get('total')?.value }}</span>
            <span class="text-lg ml-1 text-slate-500 font-bold">€</span>
          </div>
        </div>

        @if(editingTicketId){
        <div class="grid grid-cols-3 gap-2">
          @for (method of paymentMethods; track method.id) {
          <button type="button" (click)="paymentMethod = method.id"
            class="h-10 rounded-lg font-bold text-xs uppercase tracking-widest transition-all"
            [class]="paymentMethod === method.id ? 'bg-emerald-500 text-white' : 'bg-slate-800 text-slate-300 hover:bg-slate-700'">
            {{ method.name }}
          </button>
          }
        </div>
        }

        <div class="flex gap-2">
          @if(editingTicketId){
          <!-- Calculadora de cambio opcional: para sacar el ticket directamente sin ella, cambia el (click) por:
               (click)="checkoutOrder()" -->
          <button (click)="finalizeCheckout()" type="button" [disabled]="saveForm.invalid || saving || !paymentMethod"
            [title]="paymentMethod ? '' : 'Selecciona el método de pago'"
            class="flex-1 h-14 bg-emerald-600 text-white hover:bg-emerald-500 active:scale-95 rounded-xl font-black text-xs tracking-widest transition-all uppercase disabled:opacity-30">
            Sacar ticket
          </button>
          }
          <button (click)="sendOrder()" type="button" [disabled]="saveForm.invalid || saving"
            class="flex-1 h-14 bg-blue-600 text-white hover:bg-blue-500 active:scale-95 rounded-xl font-black text-xs tracking-widest transition-all uppercase disabled:opacity-30">
            {{ editingTicketId ? 'Actualizar pedido' : 'Enviar pedido' }}
          </button>
        </div>
      </div>
    </section>
  </div>

  <!-- Barra inferior móvil: alterna carta / comanda -->
  <nav class="md:hidden fixed bottom-0 inset-x-0 z-30 bg-white border-t border-slate-200 p-2 grid grid-cols-2 gap-2 shadow-[0_-8px_24px_rgba(0,0,0,0.08)]">
    <button type="button" (click)="mobilePanel = 'menu'"
      class="h-14 rounded-xl font-black text-xs uppercase tracking-widest transition-all"
      [class]="mobilePanel === 'menu' ? 'bg-slate-900 text-white' : 'bg-slate-100 text-slate-600'">
      Carta
    </button>
    <button type="button" (click)="mobilePanel = 'order'"
      class="h-14 rounded-xl font-black text-xs uppercase tracking-widest transition-all flex flex-col items-center justify-center leading-tight"
      [class]="mobilePanel === 'order' ? 'bg-blue-600 text-white' : 'bg-blue-50 text-blue-700'">
      <span>Comanda ({{ orderedUnits }})</span>
      <span class="text-sm">{{ saveForm.get('total')?.value }} €</span>
    </button>
  </nav>

</form>
}

@if(showChangeCalculator){
<change-calculator [amountDue]="saveForm.get('total')?.value" confirmLabel="Cobrar y sacar ticket"
  (closeFunction)="showChangeCalculator = false" (acceptFunction)="checkoutOrder()"></change-calculator>
}

@if(editMeasures){
<document-special-measures-form [specialMeasures]="specialMeasures" (closeFunction)="toggleEditMeasures()"
  (acceptFunction)="acceptMeasures($event)"></document-special-measures-form>
}
